.priceDropsEmptyMessage {
  width: 100%;
  max-width: 100%;
  margin: 0.75rem -0.75rem 0.5rem 0.75rem;
  padding: 0.5rem 1.8125rem 2.625rem;
  border-radius: 0.5rem;

  @media (min-width: 769px) {
    border-radius: 1rem;
  }

  img {
    display: block;
    height: 12rem;
    margin: 0.4375rem auto 1.1875rem;
  }

  .text {
    display: flex;
    flex-direction: column;
    max-width: 18rem;
    line-height: 150%;
    text-align: center;
    row-gap: 0.625rem;
    margin: 0 auto;
  }
}
